import service from '../index';
import { convertLabelsToTranslate } from '@/services/translate/translateMapper';
const controlName = 'configTranslate';

const getTranslate = async ({ companyId }) => {
  if (!companyId) return null;

  const translationsLocal = localStorage.getItem('companyTranslations');

  if (!translationsLocal) {
    const dataFromApi = await service.get(controlName, companyId);
    if (dataFromApi && Object.keys(dataFromApi).length > 0) {
      localStorage.setItem('companyTranslations', JSON.stringify(dataFromApi));
    }
    return await convertLabelsToTranslate(dataFromApi);
  }

  return await convertLabelsToTranslate(JSON.parse(translationsLocal));
};

export { getTranslate };
